'use strict';

require('../../style/');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/lib/flex/style/index.js
// module id = 1112
// module chunks = 0 2 3 4 5 6 7 8 9 10 12 13 16 18 19 20 21 22 23 24 25 26 27 28 29 30 32 33 34 37 38 39 40 41 42 43 44 45